module.exports = __webpack_public_path__ + "static/media/bsas.61344314.jpeg";